module.exports = __webpack_public_path__ + "static/media/inconnect_logo.6e580723.svg";